/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum InputName {
  all_in_cost = 'all_in_cost',
  financial_risk = 'financial_risk',
  employee_monthly_contribution = 'employee_monthly_contribution',
  deductible = 'deductible',
  oop_max = 'oop_max',
  free_referrals = 'free_referrals',
  prefers_hsa = 'prefers_hsa',
  provider_coverage = 'provider_coverage',
  drug_coverage = 'drug_coverage',
  metal_level = 'metal_level',
  anticipated_care_level = 'anticipated_care_level',
  plan_types = 'plan_types',
  provider = 'provider',
  drug = 'drug',
  carrier = 'carrier',
  dependent_included = 'dependent_included',
  priority_level = 'priority_level',
  priority_order = 'priority_order',
  priority_weights = 'priority_weights',
}
